import * as React from 'react';
import { useUiStore } from '@/store/uiStore';
import { GradientModal } from '@/components/ui/GradientModal';
import { Button } from '@/components/ui/Button';
import { useNavigate } from 'react-router-dom';

export const TermsModal: React.FC = () => {
  const isOpen = useUiStore((state) => state.modals.terms);
  const closeModal = useUiStore((state) => state.closeModal);
  const navigate = useNavigate();

  const handleDecline = () => {
    closeModal('terms');
  };

  const handleAccept = () => {
    closeModal('terms');
  };

  return (
    <GradientModal
      isOpen={isOpen}
      onClose={() => closeModal('terms')}
      variant='purple'
      className='max-w-[728px] fold:max-w-[95vw]'
      hideCloseButton={true}
      contentClassName='!py-[31px] !pr-[20px] !pl-[20px] fold:!pl-[40px]'
    >
      <div className='flex flex-col items-center pt-0'>
        {/* Header */}
        <div className='mb-8 text-center font-sans text-24 font-bold leading-[32px] text-brand-800 fold:text-32 fold:leading-[40px]'>
          <div>DECHOES</div>
          <div>Key Terms & AI Transparency Notice</div>
        </div>

        <div className='mb-8 w-full space-y-6 pr-2 text-left'>
          <section>
            <h4 className='mb-[10px] font-sans text-16 font-medium leading-27 text-dark-100 fold:text-20'>
              Acceptance of Full Terms
            </h4>
            <p className='font-sans text-14 font-normal leading-24 text-gray-600 fold:text-16'>
              These Key Terms constitute a summary and presentation layer of the Company’s
              contractual terms. By accepting these Terms, you expressly acknowledge and agree that
              you also accept and are legally bound by the Company’s full Terms and Conditions, as
              published and made available within the Application and on the Website, which are
              incorporated herein by reference. In the event of any inconsistency, the full Terms
              and Conditions shall prevail.
            </p>
          </section>

          <section>
            <h4 className='mb-[10px] font-sans text-16 font-medium leading-27 text-dark-100 fold:text-20'>
              Service Provider
            </h4>
            <p className='font-sans text-14 font-normal leading-24 text-gray-600 fold:text-16'>
              The DECHOES application is operated by DECHOAI S.R.L., a company duly incorporated
              under the laws of Romania (the Company, we, us).
              <br />
              Contact: support@dechoai.com
            </p>
          </section>

          <section>
            <h4 className='mb-[10px] font-sans text-16 font-medium leading-27 text-dark-100 fold:text-20'>
              Nature of the Service
            </h4>
            <p className='font-sans text-14 font-normal leading-24 text-gray-600 fold:text-16'>
              DECHOES is an artificial intelligence–based digital service enabling Users to interact
              with AI- generated digital avatars (“Echoes”) through automated systems.
            </p>
          </section>

          <section>
            <h4 className='mb-[10px] font-sans text-16 font-medium leading-27 text-dark-100 fold:text-20'>
              Definition of an Echo
            </h4>
            <p className='font-sans text-14 font-normal leading-24 text-gray-600 fold:text-16'>
              An Echo is a synthetic, AI-generated digital simulation of a natural person, produced
              through automated processing of data and prompts, capable of generating interactive
              content (including text, voice, images, or audiovisual material) that may resemble a
              person’s appearance, voice, personality traits, communication style, or knowledge
              domain.
            </p>
          </section>

          <section>
            <h4 className='mb-[10px] font-sans text-16 font-medium leading-27 text-dark-100 fold:text-20'>
              For the avoidance of doubt:
            </h4>
            <ul className='list-disc pl-5 font-sans text-14 font-normal leading-24 text-gray-600 marker:text-brand-800 fold:text-16'>
              <li>An Echo is not a human being</li>
              <li>An Echo has no legal personality, intent, consciousness, or authority</li>
              <li>
                An Echo cannot give consent, form intent, create obligations, or represent any
                natural or legal person
              </li>
              <li>
                All outputs are algorithmically generated and may be inaccurate, incomplete, or
                fictional
              </li>
            </ul>
          </section>
        </div>

        {/* Footer Actions */}
        <div className='flex w-full flex-col items-center justify-between gap-6 border-t border-gray-200 pt-6 fold:flex-row'>
          {/* Links */}
          <div className='flex flex-col gap-1 text-left'>
            <span className='font-sans text-16 font-medium leading-27 text-dark-100'>
              See Detailed
            </span>
            <div className='flex flex-wrap gap-4'>
              <button
                onClick={() => {
                  closeModal('terms');
                  navigate('/info?tab=privacy');
                }}
                className='font-sans text-14 font-normal leading-27 text-brand-800 underline decoration-solid hover:opacity-80'
              >
                Privacy Policy
              </button>
              <button
                onClick={() => {
                  closeModal('terms');
                  navigate('/info?tab=terms');
                }}
                className='font-sans text-14 font-normal leading-27 text-brand-800 underline decoration-solid hover:opacity-80'
              >
                Terms & Conditions
              </button>
              <button
                onClick={() => {
                  closeModal('terms');
                  navigate('/info?tab=cookie');
                }}
                className='font-sans text-14 font-normal leading-27 text-brand-800 underline decoration-solid hover:opacity-80'
              >
                Cookie Policy
              </button>
            </div>
          </div>

          {/* Buttons */}
          <div className='flex gap-4'>
            <Button variant='terms-decline' onClick={handleDecline}>
              Decline
            </Button>
            <Button variant='terms-accept' onClick={handleAccept}>
              Accept
            </Button>
          </div>
        </div>
      </div>
    </GradientModal>
  );
};
